import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site-shell";
import { GenerateCta } from "@/components/generate-cta";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About DealDraft — AI Proposals for Freelancers" },
      {
        name: "description",
        content:
          "DealDraft is built by Jerame Maupin at LJ Legacy Solutions LLC to help freelancers send proposals and contracts fast.",
      },
      {
        "script:ld+json": {
          "@context": "https://schema.org",
          "@type": "Person",
          name: "Jerame Maupin",
          jobTitle: "Founder",
          worksFor: {
            "@type": "Organization",
            name: "LJ Legacy Solutions LLC",
          },
          sameAs: [
            "https://www.linkedin.com/in/jerame-maupin-83a97a373",
            "https://x.com/JerameMaupin",
            "https://github.com/jerame35",
          ],
        },
      },
    ],
    links: [{ rel: "canonical", href: "https://dealdraft.pro/about" }],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <SiteShell>
      <article className="mx-auto max-w-3xl px-6 py-16">
        <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">About DealDraft</h1>

        <div className="mt-8 space-y-10 text-base leading-relaxed text-muted-foreground">
          <p>
            DealDraft (dealdraft.pro) is built and operated by{" "}
            <strong className="text-foreground">LJ Legacy Solutions LLC</strong>, a Kansas
            company founded by Jerame Maupin.
          </p>

          <p>
            DealDraft generates a professional proposal and a matching contract from a short
            form in about a minute.
          </p>

          <section>
            <h2 className="text-xl font-semibold tracking-tight text-foreground">Founder</h2>
            <p className="mt-4">
              Jerame Maupin is the founder of LJ Legacy Solutions LLC, where he builds software
              for freelancers and small businesses. He created DealDraft to give independent
              professionals a faster way to send polished proposals and contracts.
            </p>
            <div className="mt-5 flex flex-wrap gap-5">
              <a
                href="https://www.linkedin.com/in/jerame-maupin-83a97a373"
                target="_blank"
                rel="me noopener"
                className="font-medium text-foreground underline hover:no-underline"
              >
                LinkedIn
              </a>
              <a
                href="https://x.com/JerameMaupin"
                target="_blank"
                rel="me noopener"
                className="font-medium text-foreground underline hover:no-underline"
              >
                X
              </a>
              <a
                href="https://github.com/jerame35"
                target="_blank"
                rel="me noopener"
                className="font-medium text-foreground underline hover:no-underline"
              >
                GitHub
              </a>
            </div>
          </section>

          <p>
            <GenerateCta
              unstyled
              className="cursor-pointer font-medium text-foreground underline hover:no-underline"
            >
              Try DealDraft free →
            </GenerateCta>
          </p>
        </div>
      </article>
    </SiteShell>
  );
}
